import "../../styles/Dataset.css";
import "./ETLPage.css";
import axios from "axios";
import { Datasets } from "../../components/Dataset/Dataset";
import NavigationBar from "../../components/NavBar/NavBar";
import DatasetWorkspaceShell from "../../components/Dataset/DatasetWorkspaceShell";
import "../../styles/DatasetPage.css";
import "../../styles/org-buttons.css";
import { useCatalog, useJob } from "../../components/Classification/ClassificationWorkflow";
import ConfigModal from "./ConfigModal/ConfigModal";
import { ETLConfig } from "../../constant/ETLconfig";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { buttonText } from "../../utils/buttonText";
import { notificationText } from "../../utils/notificationText";
import { pageText } from "../../utils/pageText";

function ETLPage(props) {
  const [selectedDatasets, setSelectedDatasets] = useState([]);
  const [showBatchETLModal, setShowBatchETLModal] = useState(false);
  const [batchETLParams, setBatchETLParams] = useState({ table_name: "", Application: "", Split: "", Liveness: "" });
  const [batchLoading, setBatchLoading] = useState(false);

  // 添加一个状态来触发刷新
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const userToken = Cookies.get("user_token");
  const userData = userToken ? jwtDecode(userToken) : null;
  const role = userData ? userData.role : null;
  const organization = userData ? userData.organization : null;

  // 刷新数据集列表的函数
  const refreshDatasets = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  // 批量ETL处理函数
  const handleBatchETL = async (params) => {
    setBatchLoading(true);

    try {
      // 1. 并行获取所有 importingPath
      const annoPathList = [];
      const res = await axios.post('/ETL/dataset/info_batch', {
        dataset_names: selectedDatasets
      });
      const datasetInfoList = res.data;
      console.info("datasetInfoList", datasetInfoList);
      for (const datasetname of datasetInfoList) {
        let urlParams;
        if (datasetname.project_id) {
          urlParams = new URLSearchParams({
            dataset_name: datasetname.name,
            project_id: datasetname.project_id
          });
        } else {
          urlParams = new URLSearchParams({
            dataset_name: datasetname.name,
          });
        }
        console.info("urlParams", urlParams);
        let importingPath;
        // audio + Label Studio → LS export；其余（含 audio+CVAT）走 CVAT/ETL
        if (
          datasetname.media_type === "audio" &&
          datasetname.project_id &&
          datasetname.anno_key !== "cvat"
        ) {
          const res = await axios.get(`/label_studio/project/export?${urlParams.toString()}`);
          importingPath = res.data.importing_json_path;
        } else {
          const res = await axios.get(`/etl/datasets/load_annotations?${urlParams.toString()}`);
          importingPath = res.data.importing_xml_path;
        }
        annoPathList.push({
          datasetName: datasetname.name,
          importingPath,
        });
      }

      const allImportingPaths = annoPathList.map(item => item.importingPath);

      // 3. 后续依次处理
      const query = new URLSearchParams({
        source_datasets: JSON.stringify(selectedDatasets),
        file_name: allImportingPaths,
        Application: params.Application,
        Split: params.Split,
        Liveness: params.Liveness,
        table_name: params.table_name,
        Organization: organization,
      }).toString();
      await axios.put(`/ETL/table/dump?${query}`);
      window.alert(`ETL labels in dataset to table success`);

      // ETL完成后刷新界面
      refreshDatasets();

    } catch (error) {
      let errorMsg = error.response?.data || error.message;
      window.alert(`Batch ETL failed: ${errorMsg}`);
    }
    setBatchLoading(false);
  };


  // 打开/关闭 Modal
  const handleShowBatchETLModal = () => setShowBatchETLModal(true);
  const handleCloseBatchETLModal = () => setShowBatchETLModal(false);

  // 提交Modal表单
  const handleBatchETLSubmit = (e) => {
    e.preventDefault();
    handleCloseBatchETLModal();
    handleBatchETL(batchETLParams);
  };

  return (
    <div>
      <NavigationBar />
      <DatasetWorkspaceShell mainClassName="ETL-page">
        <Datasets
          key={refreshTrigger}
          refreshDatasets={refreshDatasets}
          hideCreateButton={true}
          overviewTitle="ETL"
          overviewDescription="Extract annotations from selected datasets and transform them into structured tables."
          extraButtons={
            selectedDatasets.length > 0 && (
              <button
                type="button"
                className="org-btn org-btn-primary"
                onClick={handleShowBatchETLModal}
                disabled={batchLoading}
              >
                {buttonText(batchLoading ? "Batch Processing..." : `Batch ETL (${selectedDatasets.length})`)}
              </button>
            )
          }
          CustomizedContent={props => (
            <CustomizedContent
              {...props}
              selectedDatasets={selectedDatasets}
              setSelectedDatasets={setSelectedDatasets}
              refreshDatasets={refreshDatasets}
            />
          )}
        />
        {selectedDatasets.length > 0 && (
          <div className="etl-selected-panel">
            <div className="etl-selected-title">
              {pageText(`Selected Datasets (${selectedDatasets.length})`)}
            </div>
            <div className="etl-selected-list">
              {selectedDatasets.map(name => (
                <span className="etl-selected-chip" key={name}>
                  {name}
                  <button
                    type="button"
                    onClick={() => setSelectedDatasets(selectedDatasets.filter(n => n !== name))}
                    aria-label={buttonText(`Remove ${name}`)}
                  >
                    {buttonText("x")}
                  </button>
                </span>
              ))}
            </div>
          </div>
        )}
      </DatasetWorkspaceShell>

      {/* 批量ETL参数Modal */}
      <Modal show={showBatchETLModal} onHide={handleCloseBatchETLModal} className="dataset-enterprise-modal">
        <Modal.Header closeButton closeLabel={buttonText("Close")} className="dataset-modal-header">
          <Modal.Title>Batch ETL Custom Parameters</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleBatchETLSubmit}>
          <Modal.Body className="dataset-modal-body">
          <Form.Group>
              <Form.Label>Table Name</Form.Label>
              <Form.Control
                type="text"
                value={batchETLParams.table_name}
                onChange={e => setBatchETLParams({ ...batchETLParams, table_name: e.target.value })}
                placeholder="Please enter table name"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Application</Form.Label>
              <Form.Select
                value={batchETLParams.Application}
                onChange={e => setBatchETLParams({
                  ...batchETLParams,
                  Application: e.target.value,
                  Liveness: e.target.value === "FR" ? batchETLParams.Liveness : "",
                })}
              >
                <option value="">Please select</option>
                <option value="OD">OD</option>
                <option value="FR">FR</option>
                <option value="AUDIO">AUDIO</option>
                <option value="KPTS">KPTS</option>
              </Form.Select>
            </Form.Group>
            {batchETLParams.Application === "FR" && (
              <Form.Group>
                <Form.Label>Liveness</Form.Label>
                <Form.Select
                  value={batchETLParams.Liveness}
                  onChange={e => setBatchETLParams({ ...batchETLParams, Liveness: e.target.value })}
                >
                  <option value="">Please select</option>
                  <option value="real">real</option>
                  <option value="attack">attack</option>
                </Form.Select>
              </Form.Group>
            )}
            <Form.Group>
              <Form.Label>Split</Form.Label>
              <Form.Select
                value={batchETLParams.Split}
                onChange={e => setBatchETLParams({ ...batchETLParams, Split: e.target.value })}
              >
                <option value="">Please select</option>
                <option value="train">train</option>
                <option value="val">val</option>
                <option value="test">test</option>
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="org-modal-footer dataset-modal-footer">
            <button type="button" className="org-btn org-btn-secondary" onClick={handleCloseBatchETLModal}>
              {buttonText("Cancel")}
            </button>
            <button type="submit" className="org-btn org-btn-primary">
              {buttonText("Confirm")}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export function CustomizedContent(props) {
  let { item, selectedDatasets, setSelectedDatasets, refreshDatasets } = props;

  let [config, setConfig] = useState(ETLConfig);
  let [loading, setLoading] = useState(false);
  const [showETLModal, setShowETLModal] = useState(false);
  const [etlParams, setEtlParams] = useState({ table_name: "", Application: "", Split: "", Liveness: "" });

  const {catalog, error: embeddingCatalogError} = useCatalog(showETLModal);
  const [embeddingModel, setEmbeddingModel] = useState("dinov2_base");
  const [embeddingField, setEmbeddingField] = useState("ground_truth");
  const [embeddingError, setEmbeddingError] = useState("");
  const [embeddingResult, setEmbeddingResult] = useState(null);
  const embeddingJob = useJob(result => {setEmbeddingResult(result); refreshDatasets?.();});
  const embeddingDataset = catalog.datasets.find(d => d.name === item.name);
  const availableModels = catalog.models.filter(m => embeddingDataset?.embeddings.includes(m.id));
  const labelFields = embeddingDataset?.label_fields || [];
  const isEmbedding = etlParams.Application === "Embedding";
  const embeddingReady = availableModels.some(m => m.id === embeddingModel) && labelFields.includes(embeddingField);

  // 判断是否为 table 类型（与 Dataset.isTableDataset 对齐）
  const isTableType =
    item.media_type === "table" ||
    item.folder_type === "table" ||
    item.group === "table";

  // 判断禁用条件
  let etlDisabled = false;
  let infoTip = null;

  if (isTableType) {
    // Table类型：显示统计信息（即使为0也显示）
    infoTip = (
      <div className="etl-info-panel">
        <div className="etl-info-line">
          <strong>{pageText("Total Files:")}</strong> {item.total_samples || 0}
        </div>
        <div className="etl-info-line">
          <strong>{pageText("Total Labels:")}</strong> {item.label_count || 0}
        </div>
        {item.classes && item.classes.length > 0 ? (
          <div className="etl-classes">
            <strong>{pageText("Classes:")}</strong>
            <div className="etl-class-list">
              {item.classes.map((cls, idx) => (
                <span key={idx} className="etl-class-chip">
                  {cls}
                </span>
              ))}
            </div>
          </div>
        ) : (
          <div className="etl-classes">
            <strong>{pageText("Classes:")}</strong>
            <span className="etl-muted">{pageText("No classes yet")}</span>
          </div>
        )}
      </div>
    );
    // Table已经生成完成，不需要ETL按钮，禁用它
    etlDisabled = true;
  } else if (item.media_type === "audio") {
    if (item.cvat_task_id || item.anno_key === "cvat") {
      infoTip = (
        <div className="etl-info-panel">
          <div className="etl-info-line">{pageText("CVAT Task ID:")} {item.cvat_task_id}</div>
          {item.samples?.length > 0 && (
            <div className="etl-info-line">{pageText("Samples:")} {item.samples.length}</div>
          )}
        </div>
      );
    } else if (item.project_id) {
      infoTip = (
        <div className="etl-info-panel">
          <div className="etl-info-line">{pageText("Project ID:")} {item.project_id}</div>
          {item.samples?.length > 0 && (
            <div className="etl-info-line">{pageText("Samples:")} {item.samples.length}</div>
          )}
        </div>
      );
    } else {
      infoTip = (
        <div className="etl-warning-panel">
          {notificationText(
            "Please import to Label Studio or CVAT and annotate."
          )}
        </div>
      );
      etlDisabled = true;
    }
  } else if (item.media_type === "image") {
    if (item.cvat_task_id) {
      infoTip = (
        <div className="etl-info-panel">
          <div className="etl-info-line">{pageText("CVAT Task ID:")} {item.cvat_task_id}</div>
          {item.samples?.length > 0 && (
            <div className="etl-info-line">{pageText("Samples:")} {item.samples.length}</div>
          )}
        </div>
      );
    } else {
      infoTip = (
        <div className="etl-warning-panel">
          {notificationText(
            "Annotation ETL requires CVAT or Label Studio. For classification labels and DINO features, select Application Embedding."
          )}
        </div>
      );
      etlDisabled = true;
    }
  }

  const userToken = Cookies.get("user_token");
  const userData = userToken ? jwtDecode(userToken) : null;
  const role = userData ? userData.role : null;
  const organization = userData ? userData.organization : null;

  // ETL 逻辑，带参数
  const loadETL = async (params) => {
    setLoading(true);
    try {
      const urlParams = new URLSearchParams({
        dataset_name: item.name,
      });
      if (item.project_id) {
        urlParams.append('project_id', item.project_id);
      }
      let importingPath = "";
      if (
        item.media_type === "audio" &&
        item.project_id &&
        item.anno_key !== "cvat"
      ) {
        const res = await axios.get(`/label_studio/project/export?${urlParams.toString()}`);
        importingPath = res.data.importing_json_path;
      } else {
        const res = await axios.get(`/etl/datasets/load_annotations?${urlParams.toString()}`);
        importingPath = res.data.importing_xml_path;
      }
      const query = new URLSearchParams({
        source_datasets: JSON.stringify([item.name]),
        file_name: importingPath,
        Application: params.Application,
        Split: params.Split,
        Liveness: params.Liveness,
        table_name: params.table_name,
        Organization: organization,
      }).toString();
      await axios.put(`/ETL/table/dump?${query}`);
      window.alert(`ETL labels in dataset '${item.name}' to table success`);

      // ETL完成后刷新界面
      if (refreshDatasets) {
        refreshDatasets();
      }
    } catch (error) {
      let errorMsg = error.response?.data || error.message;
      window.alert(errorMsg);
    }
    setLoading(false);
  };

  // 打开弹窗
  const handleShowETLModal = () => {setEmbeddingError(""); setShowETLModal(true);};
  // 关闭弹窗
  const handleCloseETLModal = () => setShowETLModal(false);

  // 提交弹窗表单
  const handleETLSubmit = (e) => {
    e.preventDefault();
    if (isEmbedding) {
      if (!embeddingReady) return;
      setLoading(true); setEmbeddingError(""); setEmbeddingResult(null);
      axios.post('/classification/tables', {requesterToken: userToken, dataset_name: item.name,
        table_name: etlParams.table_name, model: embeddingModel, label_field: embeddingField, split: etlParams.Split})
        .then(({data}) => {embeddingJob.start(data.job_id); handleCloseETLModal();})
        .catch(error => setEmbeddingError(String(error.response?.data?.error || error.response?.data || error.message)))
        .finally(() => setLoading(false));
      return;
    }
    handleCloseETLModal();
    loadETL(etlParams);
  };

  return (
    <div className="ETL-customized-content">
      {/* 只有非 table 类型才显示多选框 */}
      {!isTableType && (
        <div className="etl-checkbox-wrapper">
          <input
            type="checkbox"
            checked={selectedDatasets.includes(item.name)}
            onChange={e => {
              if (e.target.checked) {
                setSelectedDatasets([...selectedDatasets, item.name]);
              } else {
                setSelectedDatasets(selectedDatasets.filter(name => name !== item.name));
              }
            }}
            className="etl-multi-select-checkbox"
          />
          <label className="etl-checkbox-label">{pageText("Select for batch ETL")}</label>
        </div>
      )}

      {infoTip}
      {embeddingJob.status && <p role="status">Embedding ETL: {embeddingJob.status}</p>}
      {embeddingJob.error && <p role="alert">{embeddingJob.error}</p>}
      {embeddingResult && <p>Created {embeddingResult.table_name} with {embeddingResult.samples} images.</p>}

      {/* 只有非 table 类型才显示 ETL 按钮 */}
      {!isTableType && (
        <div className="input-content">
          <div className="button-container">
            <button
              type="button"
              className="org-btn org-btn-primary"
              onClick={handleShowETLModal}
              disabled={loading || embeddingJob.busy || (etlDisabled && item.media_type !== "image")}
            >
              {buttonText(loading ? "Processing..." : "ETL")}
            </button>
          </div>
        </div>
      )}

      <ConfigModal item={item} config={config} setConfig={setConfig} />

      {/* 弹窗部分 */}
      <Modal show={showETLModal} onHide={handleCloseETLModal} className="dataset-enterprise-modal">
        <Modal.Header closeButton closeLabel={buttonText("Close")} className="dataset-modal-header">
          <Modal.Title>Custom ETL Parameters</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleETLSubmit}>
          <Modal.Body className="dataset-modal-body">
            <Form.Group>
              <Form.Label htmlFor={`etl-table-${item.name}`}>Table Name</Form.Label>
              <Form.Control
                id={`etl-table-${item.name}`}
                type="text"
                required={isEmbedding}
                value={etlParams.table_name}
                onChange={e => setEtlParams({ ...etlParams, table_name: e.target.value })}
                placeholder="Please enter table name"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label htmlFor={`etl-application-${item.name}`}>Application</Form.Label>
              <Form.Select
                id={`etl-application-${item.name}`}
                value={etlParams.Application}
                onChange={e => setEtlParams({
                  ...etlParams,
                  Application: e.target.value,
                  Liveness: e.target.value === "FR" ? etlParams.Liveness : "",
                })}
              >
                <option value="">Please select</option>
                <option value="OD">OD</option>
                <option value="FR">FR</option>
                <option value="AUDIO">AUDIO</option>
                <option value="KPTS">KPTS</option>
                {item.media_type === "image" && <option value="Embedding">Embedding</option>}
              </Form.Select>
            </Form.Group>
            {isEmbedding && <>
              <Form.Group><Form.Label htmlFor={`embedding-model-${item.name}`}>DINO Model</Form.Label>
                <Form.Select id={`embedding-model-${item.name}`} value={embeddingModel} onChange={e => setEmbeddingModel(e.target.value)}>
                  <option value="">Please select</option>{availableModels.map(m => <option key={m.id} value={m.id}>{m.model}</option>)}
                </Form.Select>
              </Form.Group>
              <Form.Group><Form.Label htmlFor={`embedding-field-${item.name}`}>Field</Form.Label>
                <Form.Select id={`embedding-field-${item.name}`} value={embeddingField} onChange={e => setEmbeddingField(e.target.value)}>
                  <option value="">Please select</option>{labelFields.map(field => <option key={field}>{field}</option>)}
                </Form.Select>
              </Form.Group>
              <p>Field is the image classification label (usually ground_truth), not the embedding vector or media type.</p>
              {embeddingDataset && !labelFields.length && <p role="alert">No classification label field found. Under DINO → Embedding, enable Use parent folder names as classification labels and extract embeddings, or annotate image classes first.</p>}
              {!availableModels.length && <p>Extract DINO embeddings for this dataset first.</p>}
              {(embeddingCatalogError || embeddingError) && <p role="alert">{embeddingError || embeddingCatalogError}</p>}
            </>}
            {etlParams.Application === "FR" && (
              <Form.Group>
                <Form.Label>Liveness</Form.Label>
                <Form.Select
                  value={etlParams.Liveness}
                  onChange={e => setEtlParams({ ...etlParams, Liveness: e.target.value })}
                >
                  <option value="">Please select</option>
                  <option value="real">real</option>
                  <option value="attack">attack</option>
                </Form.Select>
              </Form.Group>
            )}
            <Form.Group>
              <Form.Label htmlFor={`etl-split-${item.name}`}>Split</Form.Label>
              <Form.Select
                id={`etl-split-${item.name}`}
                value={etlParams.Split}
                onChange={e => setEtlParams({ ...etlParams, Split: e.target.value })}
              >
                <option value="">{isEmbedding ? "Automatic / existing splits" : "Please select"}</option>
                <option value="train">train</option>
                <option value="val">val</option>
                <option value="test">test</option>
              </Form.Select>
            </Form.Group>
            {isEmbedding && <p>Leave Split empty to preserve existing splits or split automatically during training. Choosing train, val or test assigns every image in this table to that split.</p>}
          </Modal.Body>
          <Modal.Footer className="org-modal-footer dataset-modal-footer">
            <button type="button" className="org-btn org-btn-secondary" onClick={handleCloseETLModal}>
              {buttonText("Cancel")}
            </button>
            <button type="submit" className="org-btn org-btn-primary" disabled={loading || embeddingJob.busy || (isEmbedding ? !embeddingReady : etlDisabled)}>
              {buttonText("Confirm")}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default ETLPage;
